<script async setup lang="ts">
import Tag from '../custom/ui/TagComponent.vue';
import EventPreview from '../custom/preview/EventPreview.vue';

import { EventEntity } from '@/entities/interfaces/events';
import { useEventStore } from '@/stores/events.store';
import { computed, ref } from 'vue';
import { useTagStore } from '@/stores/tags.store';
import { TagEntity } from '@/entities/interfaces/tag';
import { useViewStore } from '@/stores/view.store';

const tagStore = useTagStore();
const eventStore = useEventStore();

const filters = computed(() => [
  { id: 'all', name: 'Все' },
  ...(tagStore.getTags.value ?? [])
]);

const activeFilter = ref<{
  id: string;
  name: string;
}>(filters.value ? filters.value[0] : { id: 'all', name: 'Все' });

const nextEvents = computed(
  () => eventStore.getEventsTimeline.value?.nextEvents
);

const eventFilters = computed(() => {
  return filters.value?.filter((tag: TagEntity) => {
    let value = false;

    nextEvents.value.forEach((item: EventEntity) => {
      const eventTags = item.tagsId ? item.tagsId.split(',') : undefined;
      const tags = eventTags ? [...eventTags, 'all'] : ['all'];
      if (tags?.includes(tag.id)) {
        value = true;
      }
    });

    return value;
  });
});

const filteredEvents = computed<EventEntity[]>(() => {
  return nextEvents.value?.filter((event: EventEntity) => {
    return event.tagsId
      ? [...event.tagsId.split(','), 'all'].includes(activeFilter.value.id)
      : ['all'].includes(activeFilter.value?.id);
  });
});

const viewStore = useViewStore();
const view = computed(() => viewStore.getViewType.value);
</script>

<template>
  <section class="events" v-if="nextEvents?.length > 0">
    <div class="events-title">
      <h1>Предстоящие мероприятия</h1>
      <div class="events-filters">
        <Tag
          v-for="filter in eventFilters"
          :type="filter.id == activeFilter.id ? 'active-filter' : 'filter'"
          :name="filter.name"
          :key="filter.name"
          @click="() => (activeFilter = filter)"
        />
      </div>
    </div>
    <div class="events-list">
      <EventPreview
        :styles="
          view == 'large'
            ? 'max-width: 440px;  margin: 0;'
            : view == 'desktop'
              ? 'max-width: calc(50% - 20px); margin: 0;'
              : ''
        "
        v-for="event in filteredEvents"
        :key="event.id"
        :event="event"
      />
    </div>
  </section>
</template>

<style scoped lang="scss">
.events {
  &-title {
    gap: 56px;
    display: flex;
    overflow: hidden;
    padding: 80px 0 40px;
    flex-direction: column;

    @media screen and (max-width: 1024px) {
      text-align: center;
    }
  }

  &-filters {
    gap: 12px;
    display: flex;
    flex-wrap: wrap;
    scrollbar-width: none;
    -ms-overflow-style: none;

    @media screen and (max-width: 1024px) {
      flex-wrap: nowrap;
      overflow-x: auto;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-list {
    gap: 40px;
    display: flex;
    flex-wrap: wrap;
    padding: 60px 0;

    .event-item {
      margin: 0;
      max-width: 440px;
    }
  }
}
</style>
